import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// CONSTANTS
var NONE = {
  empty: true,
  name: "",
  upper: undefined,
  lower: undefined,
  type: undefined,
  additive: []
};
var NAMES = ["4/4", "3/4", "2/4", "2/2", "12/8", "9/8", "6/8", "3/8"]; // PUBLIC API

function names() {
  return NAMES.slice();
}

var REGEX = /^(\d?\d(?:\+\d)*)\/(\d)$/;
var CACHE = new Map();

function get(literal) {
  var cached = CACHE.get(literal);

  if (cached) {
    return cached;
  }

  var ts = build(parse(literal));
  CACHE.set(literal, ts);
  return ts;
}

function parse(literal) {
  if (typeof literal === "string") {
    var _ref = REGEX.exec(literal) || [],
        _ref2 = _slicedToArray(_ref, 3),
        _ = _ref2[0],
        _up = _ref2[1],
        low = _ref2[2];

    return parse([_up, low]);
  }

  var _literal = _slicedToArray(literal, 2),
      up = _literal[0],
      down = _literal[1];

  var denominator = +down;

  if (typeof up === "number") {
    return [up, denominator];
  }

  var list = up.split("+").map(function (n) {
    return +n;
  });
  return list.length === 1 ? [list[0], denominator] : [list, denominator];
}

var index = {
  names: names,
  parse: parse,
  get: get
}; // PRIVATE

function build(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      up = _ref4[0],
      down = _ref4[1];

  var upper = Array.isArray(up) ? up.reduce(function (a, b) {
    return a + b;
  }, 0) : up;
  var lower = down;

  if (upper === 0 || lower === 0) {
    return NONE;
  }

  var name = Array.isArray(up) ? "".concat(up.join("+"), "/").concat(down) : "".concat(up, "/").concat(down);
  var additive = Array.isArray(up) ? up : [];
  var type = lower === 4 || lower === 2 ? "simple" : lower === 8 && upper % 3 === 0 ? "compound" : "irregular";
  return {
    empty: false,
    name: name,
    type: type,
    upper: upper,
    lower: lower,
    additive: additive
  };
}

export default index;
export { get, names, parse };